<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="local_shipping"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('carriers') }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.is_percentage="{ item }">
          <v-chip
            :color="item.is_percentage ? 'blue' : 'green'"
            text-color="white"
          >
            {{ item.is_percentage ? $t('percentage_rate') : $t('static_rate') }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('carrier') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.name"
                  :label="$t('name')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.slug"
                  :label="$t('abbreviation')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.erp_id"
                  :label="$t('erp_id')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.volume_weight_factor"
                  :label="$t('volume_weight_factor')"
                />
              </v-col>
              <v-sheet style="width: 100%;">
                <div style="margin-bottom: 10px">
                  <div
                    style="margin-left: 10px; font-size: 14px; font-weight: 400;"
                  >
                    {{ $t('description') }}
                  </div>
                </div>
                <v-row class="mx-0">
                  <v-col
                    sm="12"
                  >
                    <v-select
                      :value="editedItem.locale"
                      :label="$t('language')"
                      dense
                      :items="languages"
                      @change="onLocaleChange"
                    />
                  </v-col>
                  <v-col
                    sm="12"
                  >
                    <v-text-field
                      v-model="editedItem.translated_message"
                      dense
                      :label="$t('description')"
                    />
                  </v-col>
                </v-row>
              </v-sheet>

              <v-sheet style="width: 100%;">
                <div style="margin-bottom: 10px">
                  <div
                    style="margin-left: 10px; font-size: 14px; font-weight: 400;"
                  >
                    {{ $t('delivery_window_in_days') }}
                  </div>
                </div>
                <v-row class="mx-0">
                  <v-col>
                    <v-text-field
                      v-model="editedItem.meta.delivery_estimate.from"
                      dense
                      :label="$t('from')"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="editedItem.meta.delivery_estimate.to"
                      dense
                      :label="$t('to')"
                    />
                  </v-col>
                </v-row>
              </v-sheet>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { SUPERUSER } from '../../../utils/constants'

  export default {
    mixins: [List],

    data () {
      return {
        name: 'carrier',
        endpoint: 'carriers',
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPERUSER.val,
        },
        headers: [
          {
            sortable: false,
            text: this.$t('name'),
            value: 'name',
            width: '100%',

          },
          {
            text: this.$t('abbreviation'),
            value: 'slug',
          },
          {
            text: this.$t('erp_id'),
            value: 'erp_id',
            type: 'number',
          },
          {
            text: this.$t('volume_weight_factor'),
            value: 'volume_weight_factor',
            type: 'number',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
          locale: '',
          meta: {
            description: {},
            delivery_estimate: {},
          },
        },
        defaultItem: {
          name: '',
          slug: '',
          erp_id: '',
          volume_weight_factor: '',
          locale: '',
          meta: {
            description: {},
            delivery_estimate: {},
          },

        },
        languages: [],

      }
    },
    mounted: function () {
      this.$get('/translation/languages')
        .then(response => {
          this.languages = response.data
        })
    },

    methods: {
      editItem (item) {
        if (!this.canUpdate()) { return }

        this.editedIndex = this.$_.findIndex(this.items, c => c.id === item.id)
        if (this.editedIndex !== -1) {
          const desc = item.meta.description || {}
          const delivery_estimate = item.meta.delivery_estimate || { from: '', to: '' }
          console.log(delivery_estimate)
          const locale = this.$_.first(Object.keys(desc)) || 'da'
          this.editedItem = Object.assign({ locale, translated_message: desc[locale] }, { ...item, meta: { description: desc, delivery_estimate } })
        }
        this.dialog = true
      },

      onLocaleChange (val) {
        this.setTranslation()
        this.editedItem.locale = val
        this.editedItem.translated_message = this.editedItem.meta.description[val]
      },
      setTranslation () {
        const oldLocale = this.editedItem.locale
        const translations = { ...this.editedItem.meta.description }
        translations[oldLocale] = this.editedItem.translated_message
        this.editedItem.meta.description = translations
      },
      doSave: function () {
        this.setTranslation()
        const { translated_message, locale, ...editedItem } = this.editedItem
        this.editedItem = editedItem
        this.save()
      },
    },
  }
</script>
